export default "__VITE_ASSET__93d4ca85__"